var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2044_75772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6895 8.17738C15.6895 7.51957 15.6361 7.03955 15.5205 6.54175H8.00458V9.51076H12.4163C12.3274 10.2486 11.8471 11.3598 10.7797 12.1064L10.7647 12.2058L13.1411 14.0457L13.3058 14.0622C14.8178 12.6665 15.6895 10.6131 15.6895 8.17738Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00537 16C10.1667 16 11.9812 15.2889 13.3066 14.0622L10.7805 12.1064C10.1045 12.5776 9.19722 12.9065 8.00537 12.9065C5.88846 12.9065 4.09176 11.5109 3.45128 9.58191L3.3574 9.58988L0.88638 11.5011L0.854065 11.5909C2.17046 14.2043 4.87443 16 8.00537 16Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45108 9.58464C3.28209 9.08684 3.18428 8.55344 3.18428 8.00232C3.18428 7.45115 3.28209 6.91781 3.44219 6.42001L3.43771 6.31399L0.935724 4.37207L0.853863 4.41098C0.311315 5.4955 0 6.71337 0 8.00232C0 9.29128 0.311315 10.5091 0.853863 11.5936L3.45108 9.58464Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00494 3.09348C9.5081 3.09348 10.5221 3.7424 11.1002 4.28469L13.3595 2.08011C11.972 0.791157 10.1663 0 8.00494 0C4.874 0 2.17003 1.79564 0.853638 4.40909L3.44196 6.41812C4.09133 4.48913 5.88803 3.09348 8.00494 3.09348Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_75772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6895,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.beb1df77f971c6748a62e97bf79b250a.svg";
export { ForwardRef as ReactComponent };